/**
 * 创作者中心- 模型详情
 * @returns
 */
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import modelImg1 from "@/assets/images/creator_model_img1.png";
import modelImg2 from "@/assets/images/creator_model_img2.png";

import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  HStack,
  Divider,
  Image,
  IconButton,
  Avatar,
  Center,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Radio,
  Textarea,
  Input,
} from "@chakra-ui/react";
import {
  RiArrowLeftWideLine,
  RiArrowRightWideLine,
  RiBox3Line,
  RiDeleteBin4Line,
  RiDownload2Line,
  RiEditBoxLine,
  RiStarLine,
  RiThumbUpLine,
  RiUpload2Line,
  RiUploadCloud2Line,
  RiUserLine,
} from "@remixicon/react";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./modelSlick.css";
import { MyModel, Tagger } from "@/types/creatorcenter";
import viplevel from "@/assets/viplevel.png";
import medal from "@/assets/medal.png";
import onekeyG from "@/assets/images/onekeygrey.svg";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import intergralIcon from "@/assets/images/icon_integral.png";
import ContentComment from "../contentdetail/contentcomment";
import {
  selectTrainingPictures,
  updateTrainingPictures,
} from "@/reducer/mymodelSlice";
import { useUpdateTaggerMutation } from "@/services/api/endpoints/model";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  imgSrc: string;
};

const MarkingPictureModal = (props: Props) => {
  const { isOpen, onClose, imgSrc } = props;
  const sliderRef = useRef<Slider>(null);
  const user = useSelector(selectUser);
  const trainingPictures = useAppSelector(selectTrainingPictures);
  const curindex = trainingPictures.findIndex(item => item.file_path === imgSrc);
  const dispatch = useAppDispatch();
  const [activeSlideIndex, setActiveSlideIndex] = useState<number>(curindex);
  // const currentModel = trainingPictures[activeSlideIndex];
  const [inputVal, setInputVal] = useState<string>("");
  const [textVal, setTextVal] = useState<string>();

  useEffect(() => {
    if (isOpen) {
      setActiveSlideIndex(curindex);
    }
  }, [isOpen]);
  useEffect(() => {
    const currentModel = trainingPictures[activeSlideIndex];
    if (currentModel && currentModel.file_content){
      setTextVal(currentModel.file_content);
    }
  }, [trainingPictures,activeSlideIndex]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    // autoplay: true,
    // autoplaySpeed: 2000,
    initialSlide: curindex,
    afterChange: (current: number) => setActiveSlideIndex(current),
  };

  const [updateTagger] = useUpdateTaggerMutation();

  const handleChangeCurrentSlide = (index: number) => {
    sliderRef.current?.slickGoTo(index);
    setActiveSlideIndex(index);
  };

  

  const taggerTrainArr = trainingPictures.filter(
    (item) => item.file_content !== "" && item.file_content !== undefined
  );
  const taggerArr:Tagger[] = taggerTrainArr.map((item) => {
    return {
      fileName: item.file_id || "",
      fileContent: item.file_content || "",
    };
  });

  

  const handleTextAreaBlur = () => {
    console.log(textVal,"111")
    const newTaggerArr = taggerArr.map((item) => {
      if (item.fileName === trainingPictures[activeSlideIndex].id) {
        return {
          fileName: item.fileName,
          fileContent: textVal!,
        };
      } else return item;
    });
    updateTagger({ userId: user.id, tagger: newTaggerArr });

    const newTrainingPictures = trainingPictures.map((item) => {
      if (item.file_id === trainingPictures[activeSlideIndex].file_id) {
        return {
          ...item,
          tag: textVal,
        };
      } else return item;
    });
    dispatch(updateTrainingPictures(newTrainingPictures));
  }

  const handleChangeTagger = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // const taggerArr = trainingPictures.filter(item=> item.tag !=="" && item.tag !==undefined)
    // const taggerArr2:Tagger[] = taggerArr.map(item => {
    //   return {
    //     fileName: item.id || "",
    //     fileContent: item.tag || ""
    //   }
    // })
    const newValue = e.target.value;
    setTextVal(newValue);
  };

  const handleChangeInputVal = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputVal(e.target.value);
  };

  const handleAddHead = () => {
    const newTaggerArr = taggerArr.map((item) => {
      return {
        fileName: item.fileName,
        fileContent: inputVal + item.fileContent,
      };
    });
    updateTagger({ userId: user.id, tagger: newTaggerArr });

    const newTrainingPictures = trainingPictures.map((item) => {
      return {
        ...item,
        file_content: inputVal + item.file_content,
      }
    });
    dispatch(updateTrainingPictures(newTrainingPictures));
  };

  const handleAddEnd = async () => {
    const newTaggerArr = taggerArr.map((item) => {
      return {
        fileName: item.fileName,
        fileContent: item.fileContent + inputVal,
      };
    });
    await updateTagger({ userId: user.id, tagger: newTaggerArr });

    const newTrainingPictures = trainingPictures.map((item) => {
      return {
        ...item,
        file_content: item.file_content + inputVal,
      };
    });
    dispatch(updateTrainingPictures(newTrainingPictures));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg="#fff" h="80vh">
        <ModalHeader>
          <Box h="10px"></Box>
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody>
          <Flex h={"100%"} gap="0px">
            {/* 左侧 */}
            <Flex
              width={"60%"}
              h="100%"
              margin={"0 auto"}
              flexDirection="column"
              border="1px solid #DCE0EB"
              boxSizing="border-box"
            >
              {/* 中间图 */}
              <Box flex={1} h="0" w="100%" position={"relative"}>
                <Flex w="100%" h="100%" alignItems={"center"}>
                  <Box w={"calc(100% - 80px)"} m="0 40px">
                    <Slider ref={sliderRef} {...settings}>
                      {trainingPictures.map((item, index) => (
                        <Box key={index}>
                          <Image
                            src={item.file_path}
                            w="100%"
                            maxH={"calc(80vh - 10.5rem - 190px)"}
                            objectFit="contain"
                          />
                        </Box>
                      ))}
                    </Slider>
                  </Box>
                </Flex>
              </Box>
              {/* 左侧列表 */}
              <Flex
                w="100%"
                h="130px"
                bg="rgba(238, 241, 247, 0.5)"
                p="20px"
                boxSizing="border-box"
                overflowX={"auto"}
                gap="20px"
              >
                {trainingPictures && trainingPictures.map((item, index) => (
                  <Box
                    key={index}
                    borderColor={
                      activeSlideIndex === index ? "#496AE1" : "#DCE0EB"
                    }
                    borderWidth="1px"
                    p="6px"
                    boxSizing="border-box"
                    cursor={"pointer"}
                    onClick={() => handleChangeCurrentSlide(index)}
                  >
                    <Image
                      boxSize="78px"
                      objectFit={"contain"}
                      src={item.file_path}
                      style={{ height: "100%" }}
                    />
                  </Box>
                ))}
              </Flex>
            </Flex>
            {/* 右侧 */}
            {trainingPictures[activeSlideIndex]?.file_content!="" && (
              <Flex
                w="40%"
                h="100%"
                border="1px solid #DCE0EB"
                p="12px"
                borderLeft={"none"}
                boxSizing="border-box"
                flexDirection={"column"}
              >
                <Textarea
                  w="100%"
                  flex={1}
                  mb="25px"
                  placeholder="请输入提示词"
                  borderRadius={0}
                  bgColor="#EEF1F7"
                  lineHeight={"25px"}
                  border={"none"}
                  fontSize="14px"
                  color={"#27314D"}
                  rows={7}
                  value={textVal}
                  onChange={handleChangeTagger}
                  onBlur={handleTextAreaBlur}
                />
                <Box color={"#27314D"} fontSize="18px" mb="13px">
                  为所有图片添加
                </Box>
                <Input
                  w="100%"
                  placeholder="请输入内容"
                  borderRadius={0}
                  bgColor="#EEF1F7"
                  h="60px"
                  border={"none"}
                  fontSize="14px"
                  color={"#27314D"}
                  value={inputVal}
                  onChange={handleChangeInputVal}
                />
                <Flex mt="25px" mb="10px" justifyContent={"end"} gap="10px">
                  <Button
                    borderRadius={0}
                    width={"110px"}
                    height={"40px"}
                    color="#FFFFFF"
                    bgColor="#496AE1"
                    fontWeight={"normal"}
                    fontSize="14px"
                    _hover={{
                      bgColor: "#3F5BC1",
                      color: "#E6E6E6",
                    }}
                    position={"relative"}
                    onClick={handleAddHead}
                  >
                    添加到行首
                  </Button>
                  <Button
                    borderRadius={0}
                    width={"110px"}
                    height={"40px"}
                    color="#FFFFFF"
                    bgColor="#496AE1"
                    fontWeight={"normal"}
                    fontSize="14px"
                    _hover={{
                      bgColor: "#3F5BC1",
                      color: "#E6E6E6",
                    }}
                    position={"relative"}
                    onClick={handleAddEnd}
                  >
                    添加到行尾
                  </Button>
                </Flex>
              </Flex>
            )}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default MarkingPictureModal;
